import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Close12, Close14 } from '../../icons';
import { Close6 } from '../../icons/Close6';
import { IconButton } from '../IconButton';
import classes from './CloseButton.module.scss';
export function CloseButton(props) {
    const { className, skin, size = 'small', disabled } = props, rest = _object_without_properties(props, [
        "className",
        "skin",
        "size",
        "disabled"
    ]);
    const sizeIconMap = {
        xsmall: /*#__PURE__*/ _jsx(Close6, {}),
        small: /*#__PURE__*/ _jsx(Close12, {}),
        medium: /*#__PURE__*/ _jsx(Close14, {})
    };
    return /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({
        className: cn(classes.root, className),
        skin: skin,
        size: size,
        disabled: disabled,
        type: "button"
    }, rest), {
        children: sizeIconMap[size]
    }));
}
